import { cn } from '@lib/cn'
import NextImage, { ImageLoader, ImageProps } from 'next/image'
import * as qs from 'query-string'
import { FC } from 'react'

export type ImgixImageProps = Omit<ImageProps, 'src'> & {
  src: string
  imgClassName?: string
}

/**
 * A Next.js Image component that loads an Imgix image.
 * @param src - The source of the image, must be an Imgix image URL
 */
export const ImgixImage: FC<ImgixImageProps> = ({
  src,
  className,
  style,
  imgClassName,
  ...rest
}) => {
  return (
    <div className={cn('relative flex w-full overflow-hidden', className)} style={style}>
      <NextImage
        src={src}
        loader={imageLoader}
        fill
        className={cn('h-full w-full object-cover', imgClassName)}
        {...rest}
      />
    </div>
  )
}

const imageLoader: ImageLoader = ({ src, width, quality }) => {
  return `${src}?${qs.stringify({ w: width, q: quality, auto: 'format' })}`
}
